import { createContext, useCallback, useContext, useState } from "react";
import { translations } from "./translations";
import { privacyTexts } from "./privacy";

export const LANGS = ["cs", "ru", "en"];
export const LANG_LABELS = { cs: "CZ", ru: "RU", en: "EN" };

const LanguageContext = createContext(null);

function detect() {
  const saved = localStorage.getItem("vita-lang");
  if (saved && LANGS.includes(saved)) return saved;
  const nav = (navigator.language || "cs").slice(0, 2).toLowerCase();
  return LANGS.includes(nav) ? nav : "cs";
}

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(detect);
  const setLang = useCallback((l) => {
    if (!LANGS.includes(l)) return;
    setLangState(l);
    localStorage.setItem("vita-lang", l);
  }, []);
  return (
    <LanguageContext.Provider value={{ lang, setLang, t: { ...translations[lang], privacy: privacyTexts[lang] } }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  return useContext(LanguageContext);
}
